import { atom } from "recoil";
export const balanceClientAtom = atom({
  key: "balanceAtom",
  default: [],
});
